import VideoCall from '@mui/icons-material/VideoCall';
import { Box, MenuItem } from '@mui/material';
import { useProduct } from '@revenuewell/front-end-bundle';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { FC, useCallback } from 'react';
import { PatientActionsContact } from '../types/patient-info';

export interface VideoCallActionProps {
  onClose: () => void;
  contact?: PatientActionsContact;
}

export const VideoCallAction: FC<VideoCallActionProps> = (props) => {
  const { onClose, contact } = props;
  const { hasProduct } = useProduct();
  const { publish } = useEventBus();

  const handleVideoClick = useCallback(() => {
    if (!contact || !contact.id) return;

    publish({
      messageType: 'start-virtual-visit',
      data: {
        contactId: contact.id,
        contactLocationId: contact.location!.id,
        contactCellPhone: contact.cellPhone!
      }
    });
    onClose();
  }, [publish, onClose, contact]);

  if (contact && contact.id && hasProduct('virtualvisits'))
    return (
      <MenuItem onClick={handleVideoClick}>
        <VideoCall color="primary" />
        <Box sx={{ margin: '0 20px 0 10px' }}>Video</Box>
      </MenuItem>
    );
  else return null;
};
